import { request } from "../_helpers/Auth";

const namespace = "/api";

export const getBadgeusesEstablishments = (_id) => {
    return request({
        url: namespace + "/badgeuses/establishment/" + _id,
        method: "get",
    });
};

export const addBadgeuse = (establishment_id, payload) => {
    return request({
        url: namespace + "/establishment/" + establishment_id + "/badgeuse",
        method: "post",
        data: payload,
    });
};

export const addBadgeage = (payload) => {
    return request({
        url: namespace + "/badgeage/",
        method: "post",
        data: payload,
    });
};

export const editBadgeuse = (badgeuse_id, payload) => {
    return request({
        url: namespace + "/badgeuse/" + badgeuse_id,
        method: "put",
        data: payload,
    });
};

export const getBadgeages = (payload) => {
    return request({
        url: namespace + "/badgeages/",
        method: "post",
        data: payload,
    });
};

export const getUsersBadgeuse = (_id) => {
    return request({
        url: namespace + "/badgeuse/" + _id + "/users",
        method: "get",
    });
};

export const deleteBadgeuse = (_id) => {
    return request({
        url: namespace + "/badgeuse/" + _id,
        method: "delete",
    });
};
